import { z } from 'zod';

export const REPORT_REASONS = [
  'harassment',
  'sexual',
  'threat',
  'hate',
  'spam',
  'doxxing',
  'underage',
  'other',
] as const;
export const ReportReasonSchema = z.enum(REPORT_REASONS);
export type ReportReason = z.infer<typeof ReportReasonSchema>;

export const REPORT_TARGETS = [
  'spark',
  'whisper_message',
  'circle_message',
  'pro_message',
  'user',
  'room',
] as const;
export const ReportTargetSchema = z.enum(REPORT_TARGETS);
export type ReportTarget = z.infer<typeof ReportTargetSchema>;

/* POST /api/reports */
export const CreateReportSchema = z.object({
  target: ReportTargetSchema,
  /** id of the message / user / room being reported. */
  targetId: z.string(),
  reason: ReportReasonSchema,
  detail: z.string().max(500).optional(),
  /**
   * The exact content the reporter chooses to attach. This is the ONLY message
   * text that ever reaches a moderator — nothing else is queryable by admins.
   */
  includeSnapshot: z.boolean().default(true),
  snapshotText: z.string().max(2000).optional(),
  /** Opaque R2 key of an attached message image — same "only what's attached"
   * rule as `snapshotText`. Only meaningful for `target: 'whisper_message'` or
   * `'pro_message'`. */
  snapshotImageKey: z.string().optional(),
});
export type CreateReport = z.infer<typeof CreateReportSchema>;

export const CreateReportResponseSchema = z.object({
  ok: z.literal(true),
  reportId: z.string(),
});
export type CreateReportResponse = z.infer<typeof CreateReportResponseSchema>;
